import Proxy from "./Proxy"

class SupportContractProxy extends Proxy {
  constructor(parameters = {}) {
    super("support-contracts", parameters)
  }
}

export default SupportContractProxy
